<template>
  <div :class="'mark__container ' + (isClusterType ? 'no-border' : '')">
    <div class="mark__title">
      <span class="fw-bold">{{ $tc("note.title", 2) }} </span>
      <span class="coefficent"
        >{{ $t("note.coefficient") }} : <span class="fw-bold">{{ coefficient }}</span></span
      >
    </div>
    <div class="mark__list">
      <div v-for="(item, index) in marks" :key="index" class="mark__item">
        <div v-if="item.profile">
          <span>{{ setProfileLabel(item.profile) }} : </span>
          <span class="fw-bold">{{ item.mark ? item.mark : "--" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { triadManager } from "@/services/triad/triad-manager";

export default {
  name: "QuestionMarkBlockComponent",
  props: {
    marks: {
      type: Array,
      required: true,
    },
    coefficient: {
      type: Number,
      required: false,
      default: 1,
    },
    isClusterType: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(usePlatformStore, {
      apprenticeProfileLabel: (store) => store.apprenticeProfileLabel,
      tutorProfileLabel: (store) => store.tutorProfileLabel,
      apprenticeMasterProfileLabel: (store) => store.apprenticeMasterProfileLabel,
      studeaManagerProfileLabel: (store) => store.studeaManagerProfileLabel,
    }),
  },
  methods: {
    setProfileLabel(key) {
      return triadManager.setProfileLabel(
        key,
        this.apprenticeProfileLabel,
        this.tutorProfileLabel,
        this.apprenticeMasterProfileLabel,
        this.studeaManagerProfileLabel,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mark {
  &__container {
    color: var(--primary-color);
    margin-top: 20px;
    padding-top: 10px;
    border-top: 1px dashed #bfc9d4;

    &.no-border {
      border-top: none;
    }
  }

  &__title {
    display: flex;
    justify-content: space-between;
  }
}
</style>
